import { useEffect, useRef } from "react"
import { useRequest } from "./useRequest"
import { userStore } from "../store/userStore"
import { unpaidOrderStore } from "../store/unpaidOrderStore"
import { Ticket } from "../types/entities/ticket"
import { isUnpaid } from "../features/tickets/ticketUtils"

const POLL_MS = 5000

export async function fetchUnpaidTicket(
    requestData: ReturnType<typeof useRequest>["requestData"],
): Promise<Ticket | null> {
    const res = await requestData<Ticket[]>({ type: "GET", path: "user/order", disableError: true })
    if (res.status === "error" || !Array.isArray(res.data)) return null
    return res.data.find(isUnpaid) ?? null
}

/** Глобальный опрос неоплаченного заказа для badge и уведомлений. */
export function useUnpaidOrderPoll() {
    const userToken = userStore(state => state.user?.token)
    const { requestData } = useRequest()
    const requestDataRef = useRef(requestData)
    requestDataRef.current = requestData

    const refresh = async () => {
        if (!userToken) {
            unpaidOrderStore.getState().setUnpaidTicket(null)
            return
        }
        try {
            const ticket = await fetchUnpaidTicket(requestDataRef.current)
            unpaidOrderStore.getState().setUnpaidTicket(ticket)
        } catch {
            /* ignore */
        }
    }

    useEffect(() => {
        if (!userToken) {
            unpaidOrderStore.getState().setUnpaidTicket(null)
            return
        }

        unpaidOrderStore.getState().setLoading(true)
        refresh().finally(() => unpaidOrderStore.getState().setLoading(false))

        const intervalId = window.setInterval(() => {
            if (unpaidOrderStore.getState().unpaidTicket) refresh()
        }, POLL_MS)

        const onVisibilityChange = () => {
            if (document.visibilityState === "visible") refresh()
        }
        document.addEventListener("visibilitychange", onVisibilityChange)

        return () => {
            window.clearInterval(intervalId)
            document.removeEventListener("visibilitychange", onVisibilityChange)
        }
    }, [userToken])
}
